import { styled } from "styled-components";

export const Flex = styled.div`
    display: flex;
`

export const FlexJustifyBetween = styled.div`
    display: flex;
    justify-content: space-between;
`

export const FlexAlignCenter = styled.div`
    display: flex;
    align-items: center;
`

export const FlexJustifyBetweenAlignCenter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`
